//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-282907 - Remove the feature flag once UIA Products Api Port is complete
export const getIsUiaProductsApiPortEnabled = createHasFeatureSelector(
  FeatureNames.UiaProductsApiPort,
);
